import type { FunctionComponent, ReactNode } from "react"

import { Text } from "@jobteaser/spark/components/Text"
import IconGenderFemale from "@jobteaser/ui-kit/assets/icons/jds_genderFemale.svg"
import IconGenderMale from "@jobteaser/ui-kit/assets/icons/jds_genderMale.svg"
import IconGenderTransgender from "@jobteaser/ui-kit/assets/icons/jds_genderTransgender.svg"
import { Icon, ICON_SIZES } from "@jobteaser/ui-kit/dist/module/components/Icon/Icon"

import { useCompanyFetch } from "@/modules/companies/client/hooks/useCompanyFetch"

import styles from "./Parity.module.css"

type ParityParam = "men" | "women" | "others"

export const Parity: FunctionComponent = () => {
  const { dataCompany } = useCompanyFetch()

  if (!dataCompany) return null

  const {
    employeeParity: { men, women, others },
  } = dataCompany.page

  const renderParity = (type: ParityParam): ReactNode => {
    let iconId
    let textContent

    switch (type) {
      case "men":
        iconId = `#${IconGenderMale.id}`
        textContent = `${men}%`
        break
      case "women":
        iconId = `#${IconGenderFemale.id}`
        textContent = `${women}%`
        break
      case "others":
        iconId = `#${IconGenderTransgender.id}`
        textContent = `${others}%`
        break
      default:
        iconId = ""
        textContent = ""
        break
    }

    return (
      <div className={styles.parity__wrapper} data-testid={`company_parity_${type}`}>
        <Icon xlinkHref={iconId} size={ICON_SIZES.BIG} role="graphics-symbol" />
        <Text variant="body1" weight="bold" className={styles.parity__text}>
          {textContent}
        </Text>
      </div>
    )
  }

  return (
    <div className={styles.parity}>
      {men > 0 ? renderParity("men") : null}
      {women > 0 ? renderParity("women") : null}
      {others > 0 ? renderParity("others") : null}
    </div>
  )
}
